import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { CgClose } from "react-icons/cg";
import { ModalProps } from "../../interface/Modal";
import Paragraph from "./typography/Paragraph";

const Modal = ({
  open,
  onClose,
  header,
  children,
  width = "",
  headingText,
  modalPadding,
  closeOnBackdropClick = false,
  disableScroll = false,
  followerModal = false,
  onScroll, // New prop for scroll handling
  hasMore = false, // New prop to show "load more" message
}: ModalProps & {
  followerModal?: boolean;
  disableScroll?: boolean;
  onScroll?: (e: React.UIEvent<HTMLDivElement>) => void;
  hasMore?: boolean;
}) => {
  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      if (onClose) {
        onClose();
      }
    }
  };

  useEffect(() => {
    if (open) {
      document.addEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "hidden";
    } else {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return ReactDOM.createPortal(
    <>
  { followerModal? ( <div
      onClick={closeOnBackdropClick ? onClose : undefined}
      className="fixed inset-0 flex justify-center items-center transition-colors z-[51] bg-site-black/60"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={`bg-white rounded-lg shadow transition-all md:max-h-[calc(100vh-160px)] max-h-[calc(100vh-120px)] scale-100 opacity-100 m-3 ${width} ${
          modalPadding ? modalPadding : "sm:p-6 p-4"
        } flex flex-col`} // Added flex to structure content
      >
        {header && (
          <div
            className={`flex items-center justify-between gap-4 ${
              headingText ? "md:pb-5 mb-4 pb-4 border-b border-medium-grey" : ""
            }`}
          >
            <Paragraph text24 className="">
              {headingText}
            </Paragraph>
            <button
              onClick={onClose}
              className={`${
                !headingText ? "absolute right-2 top-2 z-10" : ""
              } rounded-lg text-grey-400 bg-white hover:bg-grey-500 hover:text-grey-600`}
            >
              <CgClose size={20} color="#333333" />
            </button>
          </div>
        )}
        {followerModal ? (
          <div
            className={`flex-1 ${
              disableScroll ? "" : "overflow-y-auto max-h-[70vh]"
            }`} // Scrollable content area
            onScroll={onScroll}
          >
            {children}
            {hasMore && (
              <div className="text-center py-4">
                <Paragraph>Load more</Paragraph>
              </div>
            )}
          </div>
        ) : (
          <>{children}</>
        )}
      </div>
    </div>): (  <div
    onClick={closeOnBackdropClick ? onClose : undefined} // Conditionally add onClick handler
      className="fixed inset-0 flex justify-center items-center transition-colors z-[51] bg-site-black/60 "
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={`bg-white rounded-lg shadow transition-all md:max-h-[calc(110vh-160px)] max-h-[calc(110vh-120px)] overflow-y-auto scale-100 opacity-100 m-3 ${width} ${
          modalPadding ? modalPadding : "sm:p-6 p-4"
        }`}
      >
        {header && (
          <div
            className={`flex items-center justify-between gap-4  ${
              headingText ? "md:pb-5 mb-4 pb-4 border-b border-medium-grey" : ""
            }`}
          >
            <Paragraph text24 className="">
              {headingText}
            </Paragraph>

            <button
              onClick={onClose}
              className={`${
                !headingText ? "absolute right-2 top-2 z-10" : ""
              } rounded-lg text-grey-400 bg-white hover:bg-grey-500 hover:text-grey-600`}
            >
              <CgClose size={20} color="#333333" />
            </button>
          </div>
        )}
        {children}
      </div>
    </div>
      
    )}
    </>,
    document.getElementById("modal-root")!
  );
};

export default Modal;
